/* global Steve */
"use strict";
const _ = require("lodash");
const namespace = "Glue.IconRepository.IconRegistry";
const ICON_REGISTRY_SINGLETON_KEY = Symbol.for(namespace);
const globalSpace = typeof window === "undefined" ? global : window;
const globalSymbols = Object.getOwnPropertySymbols(globalSpace);

class IconRegistry {
    constructor() {
        this._steveMode = globalSpace.Steve ? true : false;
        if (!this._steveMode) {
            this._registeredIcons = {};
        }
    }
    _doesObjectPassPropertyFilter(obj, propertyFilter) {
        return propertyFilter.every((prop) => {
            if (Object.hasOwn(obj, prop)) {
                return true;
            } else {
                return false;
            }
        });
    }
    _flattenRegistryCache(regCache, propertyFilter) {
        let flat = {};
        Object.keys(regCache).forEach((namespace) => {
            Object.keys(regCache[namespace]).forEach((name) => {
                let cacheEntry = regCache[namespace][name];
                let matches = true;
                if (propertyFilter) {
                    matches = this._doesObjectPassPropertyFilter(cacheEntry, propertyFilter);
                }
                if (matches) {
                    flat[namespace + "." + name] = cacheEntry;
                }
            });
        });
        return flat;
    }
    registerIcon(iconNamespace, icon) {
        if (this._steveMode) {
            Steve.di.registry.register(`IconRegistry.${iconNamespace}`, icon); //jshint ignore:line
        } else {
            this._registeredIcons[iconNamespace] = icon;
        }
    }
    getAllRegisterdIconsWith(...properties) {
        if (this._steveMode) {
            let regCache = Steve.di.getAllRegisteredByGlob("IconRegistry.**"); //jshint ignore:line
            return this._flattenRegistryCache(regCache, properties);
        } else {
            let matched = {};
            Object.keys(this._registeredIcons).forEach((iconNamespace) => {
                let cacheEntry = this._registeredIcons[iconNamespace];
                let matches = this._doesObjectPassPropertyFilter(cacheEntry, properties);
                if (matches) {
                    matched[iconNamespace] = cacheEntry;
                }
            });
            return matched;
        }
    }
    getAllRegisteredIcons() {
        if (this._steveMode) {
            let regCache = Steve.di.getAllRegisteredByGlob("IconRegistry.**"); //jshint ignore:line
            return this._flattenRegistryCache(regCache);
        } else {
            return _.cloneDeep(this._registeredIcons);
        }
    }
    getRegisteredIcon(iconNamespace) {
        if (this._steveMode) {
            let respObj = Steve.di.getRegistered(`IconRegistry.${iconNamespace}`); //jshint ignore:line
            return _.get(respObj, "registeredObj", undefined);
        } else {
            return this._registeredIcons[iconNamespace];
        }
    }
    static getInstance() {
        return globalSpace[ICON_REGISTRY_SINGLETON_KEY];
    }
}

//If this is the first time go ahead and create the symbol.
if (globalSymbols.indexOf(ICON_REGISTRY_SINGLETON_KEY) === -1) {
    globalSpace[ICON_REGISTRY_SINGLETON_KEY] = new IconRegistry();
}

module.exports = IconRegistry;
